"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomNpiNumber = exports.getNpiCheckDigit = exports.randomNumber = exports.databaseId = exports.randomString = void 0;
const lodash_1 = require("lodash");
const randomString = (length = 32, prefix) => {
    let result = prefix || '';
    const set = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const setLength = set.length;
    for (let i = 0; i < length; i += 1) {
        result += set.charAt(Math.floor(Math.random() * setLength));
    }
    return result;
};
exports.randomString = randomString;
const databaseId = (prefix) => {
    return (0, exports.randomString)(12, `${prefix}_`);
};
exports.databaseId = databaseId;
const randomNumber = (length = 32, includeZero = false) => {
    let result = '';
    let set = '123456789';
    if (includeZero) {
        set += '0';
    }
    const setLength = set.length;
    for (let i = 0; i < length; i += 1) {
        result += set.charAt(Math.floor(Math.random() * setLength));
    }
    return result;
};
exports.randomNumber = randomNumber;
const getNpiCheckDigit = (npi) => {
    const checkDigitMap = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
    const numberArray = npi.split('').map(Number);
    let i = 0;
    const lengthMod = numberArray.length % 2;
    return ((((0, lodash_1.sumBy)(numberArray, (d) => (i++ % 2 === lengthMod ? d : checkDigitMap[d])) + 24) * 9) % 10);
};
exports.getNpiCheckDigit = getNpiCheckDigit;
const randomNpiNumber = () => {
    const startingNumber = `1${(0, exports.randomNumber)(8)}`;
    const checkDigit = (0, exports.getNpiCheckDigit)(startingNumber);
    return Number(`${startingNumber}${checkDigit}`);
};
exports.randomNpiNumber = randomNpiNumber;
//# sourceMappingURL=generator.js.map